export enum QueryFilterConnector {
  And = 'and',
  Or = 'or',
}

export enum QueryFilterOperator {
  Equals = 'equals',
  GreaterThan = 'greater-than',
  GreaterThanOrEqual = 'greater-than-or-equal',
  In = 'in',
  IsNotNull = 'is-not-null',
  IsNull = 'is-null',
  LessThan = 'less-than',
  LessThanOrEqual = 'less-than-or-equal',
  Like = 'like',
  NotEquals = 'not-equals',
  NotLike = 'not-like',
}

export enum QuerySortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export const valuelessQueryFilterOperators: QueryFilterOperator[] = [
  QueryFilterOperator.IsNotNull,
  QueryFilterOperator.IsNull,
];
